<div #videoModal class="ss-l-zIndexVideo p-0 m-0" [ngClass]="{ 'hidden-player': !isPlayerVisible }">
  <div class="modal-header">
    <button class="close-btn-header m-0 border-none" (click)="closeModal()"><i class="bi bi-x"></i> </button>
  </div>
  <div class="modal-content p-0 m-0">
    <!-- <div [style.height.px]="height" class="p-0 m-0"> -->
    <div class="p-0 m-0 ss-video-modal-player-wrap" [style.height]="show ? '100vh' : (height ? height + 'px' : null)">
      <!-- Iframe do player Lit — criado uma vez em ngOnInit() e mantido vivo
           entre aberturas (nunca recriado); ver video-modal.component.ts. -->
      <div class="ss-lit-player-host" #iframeHost></div>
    </div>
  </div>
</div>

